export default {"src":"/kelp/_next/static/media/gain_app_logo.11fa2aed.svg","height":40,"width":94,"blurWidth":0,"blurHeight":0};